import { useState, useCallback, useEffect, useMemo } from "react";
/**
 * Handles navigation in a menu list or matrix, by holding the active item index and declaring methods for easy navigation.
 */
export function useMenuNavigation({ length, rowLength = 1, }) {
    const [activeIndex, setActiveIndex] = useState(0);
    useEffect(() => {
        setActiveIndex(0);
    }, [length]);
    const up = useCallback(() => {
        setActiveIndex((index) => {
            const targetIndex = index - rowLength;
            return targetIndex < 0 ? index : targetIndex;
        });
    }, [rowLength]);
    const down = useCallback(() => {
        setActiveIndex((index) => {
            const targetIndex = index + rowLength;
            return targetIndex >= length ? index : targetIndex;
        });
    }, [length, rowLength]);
    const left = useCallback(() => {
        setActiveIndex((index) => {
            const targetIndex = index - 1;
            return targetIndex < 0 ? index : targetIndex;
        });
    }, []);
    const right = useCallback(() => {
        setActiveIndex((index) => {
            const targetIndex = index + 1;
            return targetIndex >= length ? index : targetIndex;
        });
    }, [length]);
    const set = useCallback((index) => {
        setActiveIndex(index);
    }, []);
    return useMemo(() => ({ activeIndex, set, down, up, left, right }), [activeIndex, set, up, down, left, right]);
}
